import React from "react";

export const InlineCodeRender = (props: any) => {
    return <strong style={{ color: "red" }}>{props.value}</strong>;
};
